import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAccountId, setCurrentMediaId, setCurrentPlaylistId, setMediaType } from '../../../actions/configurationActions';

interface UseProcessMediaDataProps {
	mediaId?: string;
	accountId: string;
	playlistId?: string;
}

const useProcessMediaData = ({ mediaId, accountId, playlistId}: UseProcessMediaDataProps) => {
    const dispatch = useDispatch();

	useEffect(() => {
		accountId && dispatch(setAccountId(accountId));
		playlistId && dispatch(setCurrentPlaylistId(playlistId));
        mediaId && dispatch(setCurrentMediaId(mediaId));
		(mediaId || playlistId) && dispatch(setMediaType('video'));
	}, [mediaId, accountId, dispatch, playlistId]);

	return { mediaId };
};

export default useProcessMediaData;
